var memoize = require('@emotion/memoize').default;

var isPropValid = require('@emotion/is-prop-valid').default;

var systemProps = require('styled-system/props');

var regex = new RegExp("^(".concat(systemProps.join('|'), ")$"));
module.exports = memoize(function (prop) {
  return isPropValid(prop) && !regex.test(prop);
});